// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"d1f27f4c","84":"8a1c9f0e","211":"40e66acd","237":"d55cb45b","590":"53aa1f84","989":"651ae667"}[chunkId] + ".chunk.js";
};